<template>
  <div class="feedbackPage" :class="{'feedbackPage_navigation': isFengChaoShow}">
    <zdy-nav :leftTitle="title" @back="back"></zdy-nav>
    <div class="feedContent" ref="feedContent">
      <!-- <van-cell-group>
        <van-cell title="手机类型" :value="userInfo.phoneType === 2 ? 'Android' : 'iOS'" />
        <van-cell title="品牌型号" :value="userInfo.model" />
        <van-cell title="软件版本" :value="userInfo.versionCode" />
      </van-cell-group> -->
      <div class="card" v-if="fromType === '1'">
        <div class="title"><img src="@/assets/requiredIcon.svg" alt="">问题类型</div>
        <div class="card-content" @click="chooseFAQType">
          <span v-if="selectedFAQType" class="span1">{{ selectedFAQType }}</span>
          <span v-else class="span2">请选择</span>
          <img src="@/assets/jiantouRight2.svg" alt="">
        </div>
      </div>
      <div class="card">
        <div class="title"><img src="@/assets/requiredIcon.svg" alt="">{{fromType === '1' ? '问题描述' : '您的建议'}}
          <span>{{ FAQType.remark ? FAQType.remark.length : 0 }}/600</span>
        </div>
        <div class="card-content" style="padding-top: 12px;">
          <Input class="input-textarea" type="textarea" v-model="FAQType.remark" maxlength="600"
            :placeholder="fromType === '1' ? '请尽可能详细描述您所遇到的问题，例如: 出现问题的时间、频率、当时的操作等信息' : '请输入'"/>
          <div class="title title2">
            上传图片
            <span>{{ upFileList ? upFileList.length : 0 }}/9</span>
            <div class="tag-text">单张图片20M以内，支持 : JPEG、JPG、PNG</div>
          </div>
          <cube-upload
            v-model="upFileList"
            :action="{
              target: '/api/blade-platform/serviceInfo/upload',
              data: { fileType: 1 }
            }"
            multiple
            :size="5"
            :max="9"
            @file-success="fileSuccess"
            @file-removed="fileRemove"
            @file-submitted="fileSubmitted"
            @file-click="handleImgsClick"
            :simultaneous-uploads="1"
            @files-added="filesAdded" />
        </div>
      </div>
    </div>
    <div class="bottom-box" :style="isIphone?'':isHarmony?'padding-bottom:28px':'padding-bottom:8px'">
      <div class="bottom-btn" @click="saveInfoBefore">提 交</div>
    </div>
    <!-- <van-button type="info" size="large" class="bottomBtnClass" :disabled="btnLoading" @click="saveInfoBefore">提 交</van-button> -->
  </div>
</template>

<script>
import { getStore } from '@/utils/store'
export default {
  name: 'feedbackPage',
  data() {
    return {
      btnLoading: false,
      picker: '',
      faqTypeList: [],
      upFileList: [],
      imgList: [],
      selectedFAQType: '',
      FAQType: {
        typeID: '',
        remark: '',
        fileList: [],
      },
      initialIndex: 0,
      title: '异常反馈',
      fromType: '1',
      isSubmit: false,
      toastMsg: null
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    isIphone(){
      console.log(navigator.userAgent,12312313);
      return /iphone/gi.test(navigator.userAgent)&& (screen.height >= 812)
    },
    isHarmony(){
      console.log(navigator.userAgent,12312313);
      return /OpenHarmony/gi.test(navigator.userAgent)
    },
    isFengChaoShow() {
      return this.$store.state.isFengChaoShow
    },
  },
  created() {
    if (getStore({name: 'fromType'})) {
      this.fromType = getStore({ name: 'fromType' }).type
      if (this.fromType === '1') {
        this.title = '异常反馈'
      } else {
        this.title = '功能建议'
      }
    }
    this.toastMsg = this.$createToast({
      txt: '上传中，请稍后',
      mask: true,
      time: 60 * 1000
    })
    this.getQuestionTypeList()
  },
  methods: {
    handleImgsClick(file) {
      let url = file.response.data[0].oUrl
      let imgIndex = 0
      for(var i in this.FAQType.fileList) {
        if (this.FAQType.fileList[i] == url) {
          imgIndex = i
        }
      }
      this.initialIndex = Number(imgIndex)
      const params = {
        $props: {
          imgs: this.FAQType.fileList,
          initialIndex: 'initialIndex', // 响应式数据的key名
          loop: false
        },
        $events: {
          change: (i) => {
            // 必须更新 initialIndex
            this.initialIndex = i
          }
        }
      }
      this.$createImagePreview({ ...params }).show()
    },
    fileRemove(fileObj) {
      let temp = []
      this.FAQType.fileList.map(item => {
        if (item !== fileObj.response.data[0].oUrl) {
          temp.push(item)
        }
      })
      this.FAQType.fileList = temp
    },
    fileSubmitted(fileObj) {
      this.isSubmit = false
      this.toastMsg.show()
    },
    fileSuccess(fileObj) {
      this.isSubmit = true
      this.FAQType.fileList.push(fileObj.response.data[0].oUrl)
      // 判断ios多选情况下图片是否全部完成上传
      if (this.FAQType.fileList.length === this.upFileList.length) {
        this.toastMsg.hide()
      }
    },
    getQuestionTypeList() {
      this.$store.dispatch('questionTypeList').then((res) => {
        const { result } = res.data;
        if (res.data.status === 1000) {
          // this.faqTypeList = result
          console.log(result)
          if (result.length !== 0) {
            result.map(item => {
              let temp = {}
              temp.text = item.questionType
              temp.value = item.uuid
              this.faqTypeList.push(temp)
            })
          }
        } else {
          const toast = this.$createToast({
            txt: res.data.msg,
            time: 2000,
            type: 'error',
          });
          toast.show();
        }
      })
    },
    chooseFAQType() {
      // const column1 = [{ text: '剧毒', value: '1'}, { text: '蚂蚁', value: '2' }, { text: '幽鬼', value: '3' }]
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '问题类型',
          data: [this.faqTypeList],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      this.FAQType.typeID = selectedVal[0]
      this.selectedFAQType = selectedText[0]
    },
    cancelHandle() {
    },
    filesAdded(files) {
      const maxSize = 20 * 1024 * 1024 // 20M
      const file = files[0]
      if (this.FAQType.fileList.length >= 9) {
        file.ignore = true
        // const toast = this.$createToast({
        //   txt: '上传图片不能超过9张',
        //   time: 1500,
        //   type: 'warn',
        // });
        // toast.show();
        this.$Message.error(`上传图片格式不符合规范`);
      }
      if (file.size > maxSize) {
        file.ignore = true
        // const toast = this.$createToast({
        //   txt: '上传图片大小不超过20M',
        //   time: 1500,
        //   type: 'warn',
        // });
        // toast.show();
        this.$Message.error(`上传图片大小不超过20M`);
      }
      if (file.type !== "image/png" && file.type !== "image/jpeg" && file.type !== "image/jpg") {
        // debugger
        file.ignore = true
        // const toast = this.$createToast({
        //   txt: '上传图片格式不符合规范',
        //   time: 1500,
        //   type: 'warn',
        // });
        // toast.show();
        this.$Message.error(`上传图片格式不符合规范`);
      }
      console.log('file.ignore',file.ignore)
    },
    saveInfoBefore() {
      if (this.fromType === '1' && this.FAQType.typeID == '') {
        this.$createToast({
          type: 'warn',
          time: 1000,
          txt: '请选择问题类型'
        }).show()
      } else if (this.FAQType.remark == '') {
        this.$createToast({
          type: 'warn',
          time: 1000,
          txt: this.fromType === '1' ? '请填写问题描述' : '请填写建议'
        }).show()
      } else {
        this.saveInfo()
      }
    },
    back() {
      this.$router.push({name: 'feedbackPageIndex'});
    },
    saveInfo() {
      if (!this.btnLoading) {
        this.btnLoading = true
        this.$store.dispatch('saveQuestionFeedbackInfo', {
          keyId: this.userInfo.USER_ID,
          // keyId: 1542423194464256,
          useDevice: this.userInfo.phoneType == 2 ? '安卓' : 'iOS',
          deviceType: this.userInfo.model,
          deviceVersion: this.userInfo.versionCode,
          questionType: this.FAQType.typeID,
          question: this.FAQType.remark,
          images: this.FAQType.fileList.join(','),
          type: this.fromType,
          useType: '移动app',
        }).then((res) => {
          if (res.data.status === 1000) {
            const toast = this.$createToast({
              txt: '提交成功',
              time: 2000,
              type: 'success',
            });
            toast.show();
            setTimeout(() => {
              this.$router.replace({ name: 'feedbackPageIndex' })
            }, 1000)
          } else {
            const toast = this.$createToast({
              txt: res.data.msg,
              time: 2000,
              type: 'error',
            });
            toast.show();
          }
          setTimeout(() => {
            this.btnLoading = false
          }, 1000);
        }).catch(error => {
          const toast = this.$createToast({
            txt: error,
            time: 2000,
            type: 'error',
          });
          toast.show();
          setTimeout(() => {
            this.btnLoading = false
          }, 1000);
        })
      }
    },
  }
}
</script>

<style lang="scss">
.feedbackPage_navigation {
  margin-top: 0px !important;
  height: 100vh !important;
}
.feedbackPage {
  background-color: #F0F2F3;
  margin-top: 44px;
  height: calc(100vh - 44px);
  overflow-y: auto;
  .feedContent {
    padding: 0 12px 107px 12px;
    .cube-scroll-wrapper {
      padding: 0 10px;
    }
    .card{
      background: #FFFFFF;
      border-radius: 8px;
      padding: 0 12px;
      margin-top: 12px;
      .title{
        padding: 12px 0 12px 0;
        font-size: 15px;
        font-weight: bold;
        color: #1A1A1A;
        line-height: 21px;
        border-bottom: 1px solid #F1F2F3;
        position: relative;
        img{
          width: 8px;
          height: 8px;
          margin-right: 4px;
        }
        span{
          font-size: 13px;
          color: #BDBDBD;
          line-height: 18px;
          position: absolute;
          right: 0;
          top: 14px;
        }
      }
      .card-content{
        padding: 12px 0;
        position: relative;
        span{
          font-size: 15px;
          line-height: 20px;
        }
        .span2{
          color: #BDBDBD;
        }
        img{
          position: absolute;
          right: 0;
          top: 14px;
        }
        .input-textarea{
          textarea{
            border: none;
            outline: none;
            border-bottom: 1px solid #F1F2F3;
            resize: none;
            box-shadow: none;
            height: 187px;
            padding: 0 0 8px 0;
            font-size: 13px;
            line-height: 18px;
          }
          textarea:placeholder{
            font-size: 13px;
            color: #BDBDBD;
            line-height: 18px;
          }
        }
        .title2{
          padding: 12px 0 8px 0;
          border-bottom: none;
          span{
            top: 8px;
            line-height: 18px;
          }
          .tag-text{
            font-size: 13px;
            color: #BDBDBD;
            margin-top: 4px;
            line-height: 18px;
          }
        }
      }
    }
  }
  .cube-upload {
    width: calc(100vw - 40px);
    .cube-upload-btn-def {
      width: 98px;
      height: 98px;
    }
    .cube-upload-file{
      margin: 0 8px 8px 0;
    }
    .cube-upload-file-def {
      width: 98px;
      height: 98px;
      .cubeic-wrong{
        width: 22px;
        height: 22px;
        top: 8px;
        right: 8px;
        background: url('../../assets/imgDel.svg');
        background-size: cover;  
      }
      .cubeic-wrong::before{
        content: ''
      }
    }
    .cube-upload-file_stat{
      display: none;
    }
    .cube-upload-file .cube-upload-btn{
      margin: 0 8px 8px 0;
    }
  }
  .bottomBtnClass {
    position: fixed;
    bottom: 0;
    color: #008BFF;
    background-color: #E2EFF9;
  }  
  .van-button--info {
    border: 0px solid rgb(253, 254, 255);
  }
  .bottom-box{
    background-color: #FFFFFF;
    padding: 8px 12px 42px 12px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    .bottom-btn{
      width: calc(100vw - 24px);
      margin: 0 auto;
      background: #E5F3FF;
      border-radius: 8px;
      height: 44px;
      line-height: 44px;
      font-size: 15px;
      color: #008CFF;
      text-align: center;
    }
  }
}
.cube-picker {
  .cube-picker-cancel{
    font-size: 15px;
    color: #696969;
    padding: 0 12px;
  }
  .cube-picker-confirm{
    font-size: 15px;
    padding: 0 12px;
  }
}
.cube-picker-confirm{
  color: #008CFE;
}
</style>